import React, { type FC } from 'react';
import type { IntegrationJob } from './integrationPanelTypes';
import {
  providerClass,
  type IntegrationProviderConfig,
} from './integrationProvider';

interface IntegrationJobModalProps {
  editing: IntegrationJob;
  provider: IntegrationProviderConfig;
  guidance: string;
  rewriting: boolean;
  onGuidanceChange: (guidance: string) => void;
  onRewrite: () => void;
  onClose: () => void;
}

export const IntegrationJobModal: FC<IntegrationJobModalProps> = ({
  editing,
  provider,
  guidance,
  rewriting,
  onGuidanceChange,
  onRewrite,
  onClose,
}) => (
  <div
    className={providerClass(provider, 'modal-overlay')}
    role='presentation'
    onMouseDown={onClose}
  >
    <div
      className={providerClass(provider, 'modal')}
      role='dialog'
      aria-modal='true'
      aria-labelledby='mnd-edit-title'
      onMouseDown={(event) => event.stopPropagation()}
    >
      <div className={providerClass(provider, 'modal-header')}>
        <div>
          <h3 id='mnd-edit-title'>Edit the job</h3>
          <span className={providerClass(provider, 'modal-cadence')}>
            {editing.title}
          </span>
        </div>
        <button
          type='button'
          className={providerClass(provider, 'close-button')}
          aria-label='Close'
          disabled={rewriting}
          onClick={onClose}
        >
          ×
        </button>
      </div>
      <p className={providerClass(provider, 'modal-subtitle')}>
        Tell them how you want this job done. They'll rewrite their side of it.
      </p>
      <textarea
        value={guidance}
        onChange={(event) => onGuidanceChange(event.target.value)}
        placeholder='e.g. Only cover my own boards, and never message the team without asking me first.'
        aria-label='Guidance for rewriting the job'
      />
      <div className={providerClass(provider, 'guidance-chips')}>
        {editing.guidanceChips.slice(0, 3).map((chip) => (
          <button
            type='button'
            key={chip}
            onClick={() => onGuidanceChange(chip)}
          >
            {chip}
          </button>
        ))}
      </div>
      <div className={providerClass(provider, 'modal-footer')}>
        <button
          className={providerClass(provider, 'primary-button')}
          onClick={onRewrite}
          disabled={rewriting || !guidance.trim()}
        >
          {rewriting ? 'Rewriting…' : 'Rewrite the job'}
        </button>
        <p>You can put it back the way they had it at any point.</p>
      </div>
    </div>
  </div>
);
